// src/components/common/NavLink.tsx
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { normalizeEntityLink } from '../../utils/siteUrls';

// Żadnych dodatkowych importów typu LinkProps – unikamy konfliktów!

const NavLink = React.forwardRef((props, ref) => {
  const { children, to, style, sx, ...rest } = props;

  return (
    <RouterLink
      ref={ref}
      to={normalizeEntityLink(to)}
      {...rest}
      style={{
        textDecoration: 'none',
        cursor: 'pointer',
        ...style,
      }}
      sx={{
        ...sx,
        '&:hover': {
          textDecoration: 'underline',
          ...sx?.['&:hover'],
        },
      }}
    >
      {children}
    </RouterLink>
  );
});

NavLink.displayName = 'NavLink';

export default NavLink;
